import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import config from '../../config.json';

export const ContractInfoCard = () => {
  const rawVestaConfig = useSelector(
    (state: RootState) => state.rawVesta.config
  );
  const addrComp = (name: string, address: string) => (
    <div className='d-flex justify-content-between w-100'>
      <span>{name}</span>
      <span>
        <a
          href={`https://explorer.multiversx.com/accounts/${address}`}
          rel='noreferrer'
          target='_blank'
        >
          See on explorer
        </a>
      </span>
    </div>
  );
  const tokenComp = (name: string, address: string) => (
    <div className='d-flex justify-content-between w-100'>
      <span>{name}</span>
      <span>
        <a
          href={`https://explorer.multiversx.com/accounts/${address}`}
          rel='noreferrer'
          target='_blank'
        >
          See on explorer
        </a>
      </span>
    </div>
  );
  const hl = () => <div className='border-bottom mt-2 mb-2'></div>;
  return (
    <div className='card'>
      <div className='card-header'>General data</div>
      <div className='card-body'>
        {addrComp(
          'RAW VST Minter',
          config.contractConfiguration.rawVestaMinter.mainnet.address
        )}
        {addrComp(
          'VST/sVST/fVST Minter',
          config.contractConfiguration.treasury.mainnet.address
        )}
        {hl()}

        <div className='d-flex justify-content-between w-100'>
          <span>Current Epoch</span>
          <span>{rawVestaConfig.data?.currentEpoch}</span>
        </div>
        <div className='d-flex justify-content-between w-100'>
          <span>Snapshot start epoch</span>
          <span>{rawVestaConfig.data?.snapshotStartingEpoch}</span>
        </div>
        <div className='d-flex justify-content-between w-100'>
          <span>Processed epochs</span>
          <span>
            {(rawVestaConfig.data?.currentEpoch ?? 0) -
              (rawVestaConfig.data?.snapshotStartingEpoch ?? 0)}
          </span>
        </div>
        <div className='d-flex justify-content-between w-100'>
          <span>Last issuance epoch</span>
          <span>{rawVestaConfig.data?.lastIssuanceEpoch}</span>
        </div>
      </div>
    </div>
  );
};
